<div class="card data-card w-100" [class.expired]="this.isExpired">
  <div class="card-body">
    <div class="card-content">
      @if (document.name) {
        <h3 class="card-title">{{ document.name }}</h3>
      }
      @if (document.dueDate) {
        <span class="card-subtitle text-muted mb-1">
          {{ 'DOCUMENT_LBL_DUE' | translate:
          {dueDate:document.dueDate | toLocalTime: 'EEE dd LLLL' } | firstLetterToUppercase  }}
        </span>
      }
    </div>
    <div class="card-right ps-2">
      <div>
        <button
          class="btn btn-outline-primary"
          type="button"
          [disabled]="this.uploadCompleted$ | async"
          [title]="'DOCUMENT_PLACEHOLDER_DOCUMENT_ADD' | translate"
          (click)="newDocument.fileupload.nativeElement.click()">
          @if (!(this.uploadCompleted$ | async)) {
            <i class="mdi mdi-cloud-upload"></i>
          }
          @if (this.uploadCompleted$ | async) {
            <i class="mdi mdi-cloud-check"></i>
          }
        </button>
      </div>
    </div>
  </div>
</div>
<app-document-add #newDocument [documentId]="document.id" />
